<div>
    <h2 class="rounded rounded-2 text-center">Follow-up Assessment Details</h2>
    <p><strong>Centre Name:</strong> {{ assessmentData.centreName }}</p>
    <p><strong>Session Type:</strong> {{ assessmentData.sessionType }}</p>
    <p><strong>Date of Assessment:</strong> {{ assessmentData.date.toDate() | date: 'dd/MM/yyyy' }}</p>
    <p><strong>Child Name:</strong> {{ assessmentData.childName }}</p>
    <p><strong>Submitted By:</strong> {{ assessmentData.submittedBy }}</p>

    <div>
        <h3 class="rounded rounded-2 text-center">Questions</h3>
        <div class="row">
            <div class="col-md-10">
                <div *ngFor="let question of assessmentData.questions; let i = index">
                    <div  class="list-group-item list-group-item-secondary mb-2 rounded bg-light text-dark">
                        <p ><strong>{{ i + 1 }}. {{ question.question }}</strong></p>
                        <p ><strong >Answer:  </strong> <span class="btn bg-warning text-dark rounded-pill">{{ question.ans }} </span></p>
                        <p><strong>Remark:</strong> {{ question.remark }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
